<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import AddressCat from './AddressList'
import IndustryCat from './IndustryList'
import { mapGetters } from 'vuex'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    AddressCat,
    IndustryCat,
  },
  computed: {
    title() {
      return this.$t('setting.list.generalSetting.pengaturanUmum')
    },
    subTitle() {
      return this.$t('setting.list.generalSetting.textUmum')
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: '/setting',
        },
        {
          text: this.$t('setting.list.generalSetting.pengaturanUmum'),
        },
      ]
    },
  },
  mounted() {
    this.$store.commit('setting/SET_STATUS', 'Industry')
  },
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    />

    <form>
      <b-card class="mc-card__setting">
        <b-tabs content-class="p-3 text-muted" nav-wrapper-class="mc-tab">
          <IndustryCat
            v-if="
              hasAccessAll([
                'c4b-setumum-industrikategori:read',
                'company_categories:read',
                'company_categories:create',
                'company_categories:update',
                'company_categories:delete',
              ])
            "
            ref="industry"
            status="Industry"
          />
          <AddressCat
            v-if="
              hasAccessAll([
                'c4a-default-setumum:read',
                'address_categories:read',
                'address_categories:create',
                'address_categories:update',
                'address_categories:delete',
              ])
            "
            ref="address"
            status="Address"
          />
        </b-tabs>
      </b-card>
    </form>
  </Layout>
</template>
